import confetti from "canvas-confetti";
import { toast } from "sonner";

const colors = { 3: ["#fbbf24", "#fb923c", "#fde68a"], 7: ["#34d399", "#14b8a6", "#a7f3d0"], 30: ["#818cf8", "#8b5cf6", "#c7d2fe"] };

export const celebrateBadges = (badges) => {
  if (!badges?.length) return;
  const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  badges.forEach((b, i) => {
    toast.success(`New badge: ${b.title}`, { description: `${b.days} days of practice in a row — ${b.description.toLowerCase()}.`, duration: 7000, id: `badge-${b.days}` });
    if (reduce) return;
    const palette = colors[b.days] || colors[3];
    setTimeout(() => {
      confetti({ particleCount: 90, spread: 70, startVelocity: 35, origin: { x: 0.3, y: 0.6 }, colors: palette, disableForReducedMotion: true });
      confetti({ particleCount: 90, spread: 70, startVelocity: 35, origin: { x: 0.7, y: 0.6 }, colors: palette, disableForReducedMotion: true });
    }, i * 400);
  });
};
